var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 10.0003C1.66797 6.07195 1.66797 4.10777 2.88836 2.88738C4.10875 1.66699 6.07293 1.66699 10.0013 1.66699C13.9297 1.66699 15.8939 1.66699 17.1142 2.88738C18.3346 4.10777 18.3346 6.07195 18.3346 10.0003C18.3346 13.9287 18.3346 15.8929 17.1142 17.1133C15.8939 18.3337 13.9297 18.3337 10.0013 18.3337C6.07293 18.3337 4.10875 18.3337 2.88836 17.1133C1.66797 15.8929 1.66797 13.9287 1.66797 10.0003Z",
    stroke: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 15L5.83203 12.5",
    stroke: "#424242",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V10",
    stroke: "#424242",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 15V7.5",
    stroke: "#424242",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSquare);
export default __webpack_public_path__ + "static/media/chatSquare.8b235780f06d397f4feb28457922aaf5.svg";
export { ForwardRef as ReactComponent };